import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { BasicImage } from "../../common"
import { motion, AnimatePresence } from "framer-motion"

const StyledHeading = styled.h2`
  line-height: 1.4;
  color: #000000;
  font-weight: 700;
  margin: 0.3em 2rem 2em 2rem;
  font-size: calc(22px + (32 - 22) * ((100vw - 320px) / (1800 - 320)));
  text-align: center;
`

const LogoSwitch = ({ items, mobile }) => {
  return items?.map((logo, i) => (
    <motion.div
      ke={`logoSwitch-${i}`}
      className={`partner${i} ${mobile ? "mobile" : "desktop"}`}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { duration: 0.5 } }}
      exit={{ y: 20, opacity: 0, transition: { duration: 0.5 } }}
    >
      <BasicImage style={{ width: "100%" }} key={i} {...logo?.logo} />
    </motion.div>
  ))
}

export const PartnerLogos = ({ items, heading }) => {
  function separateIt(arr, size) {
    var newArr = []
    for (var i = 0; i < arr.length; i += size) {
      var sliceIt = arr.slice(i, i + size)
      newArr.push(sliceIt)
    }
    return newArr
  }

  const [index, setIndex] = useState(0)
  const [mobileIndex, setMobileIndex] = useState(0)
  const logos = separateIt(items, 7)
  const mobileLogos = separateIt(items, 4)

  useEffect(() => {
    if (logos?.length !== 1) {
      setInterval(() => {
        setIndex((prev) => (prev === logos?.length - 1 ? 0 : prev + 1))
      }, 4000)
    }

    if (window.screen.width < 768 && mobileLogos?.length !== 1) {
      setInterval(() => {
        setMobileIndex((prev) =>
          prev === mobileLogos?.length - 1 ? 0 : prev + 1
        )
      }, 4000)
    }
  }, [logos?.length, mobileLogos?.length])

  const remainder = logos[index]?.length % 2
  const half = (logos[index]?.length - remainder) / 2

  const StyledGridInner = styled(motion.div)`
    padding: 0 ${(props) => props.theme.wrappers.standard};
    min-height: 200px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    justify-content: center;
    width: 100%;
    column-gap: 0px;
    row-gap: 40px;

    > div {
      img {
        max-width: 125px;
        width: 100%;
      }
    }

    .desktop {
      display: none !important;
    }

    @media (min-width: 768px) {
      grid-template-columns: repeat(${(half + remainder) * 2}, 1fr);

      > div {
        display: flex;
        justify-content: center;
        align-items: center;
        grid-column: span 2;

        img {
          max-width: 200px;
          width: 100%;
        }
      }

      .partner${half + remainder} {
        grid-column-start: ${remainder === 1 ? "2" : "1"};
        grid-column-end: ${remainder === 1 ? "4" : "3"};
      }

      .desktop {
        display: flex !important;
      }

      .mobile {
        display: none !important;
      }
    }
  `

  return (
    <>
      <StyledHeading>{heading}</StyledHeading>
      <AnimatePresence exitBeforeEnter>
        <StyledGridInner
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <LogoSwitch items={logos[index]} />
          <LogoSwitch items={mobileLogos[mobileIndex]} mobile={true} />
        </StyledGridInner>
      </AnimatePresence>
    </>
  )
}
